import { AngularServices } from '../../../../modules/core';
import { RootScopeEvents } from '../../root-scope-types';
import AbstractTrack from '../abstract.track';
export default class LiveChatMessageReceivedTrack extends AbstractTrack {
    constructor() {
        super(...arguments);
        this.eventNameSegment = 'Live Chat Message Received';
    }
    start() {
        const pn = this.$injector.get(AngularServices.Pn);
        this.$rootScope.$on(RootScopeEvents.CHAT.ON_MESSAGE, (_e, person) => {
            const isPersonOnline = !!pn.people.findByUid(person.uuid);
            const isPatientForceRemoved = !!pn.forceRemovedPeople.findByUid(person.uuid);
            this.customTrackData = {
                personUuid: person.uuid,
                isPersonOnline,
                isPatientForceRemoved,
                personSystemInfo: person.getSystemInfo(),
            };
            this.trackSegment(this.customTrackData);
        });
    }
}
